import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";

import CustomInput from "../../Common/CustomInput";
import CustomSelect from "../../Common/CustomSelect";

import { getAttributeValue } from "../../../utils/profile";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  helperText: {
    width: "300px",
  },
  checkbox: {
    padding: "6px",
  },
};

const MultipleFormSection = (props) => {
  const {
    classes,
    id,
    typeId,
    title,
    title2,
    data,
    setFormValue,
    lov,
    language,
    errorMsg,
    required,
    checkbox,
  } = props;

  const renderTypeSelect = (index) => {
    return (
      <CustomSelect
        name="type"
        value={getAttributeValue(data[index], typeId) || ""}
        onChange={(e) => setFormValue(id, index, e.target.value, typeId)}
        error={!getAttributeValue(data[index], typeId)}
        options={
          lov[typeId]
            ? lov[typeId].map((v) => ({
                id: v.id,
                name: v["name_" + language],
              }))
            : []
        }
      />
    );
  };

  return (
    <Box
      style={{
        marginBottom: "10px",
        minHeight: "72px",
      }}
    >
      <span className={"text-87 bold-500"}>
        {required && <span style={{ color: colors.errorRed }}>{"* "}</span>}
        {title2 ? title2 : I18n.get(`profiles_${title}`)}
      </span>
      <span
        className="text-54"
        style={{
          marginLeft: "20px",
          fontStyle: "italic",
          fontSize: "1em",
        }}
      >
        {checkbox && data && data.length > 0
          ? I18n.get("site_ocrValuesMsg")
          : ""}
      </span>
      {data &&
        Object.keys(data).map((key, index) => (
          <Grid
            container
            wrap="nowrap"
            alignItems={errorMsg && errorMsg[key] ? "flex-start" : "center"}
            key={key}
            style={{ margin: index !== 0 ? "10px 0px" : "0px 0px 10px 0px" }}
          >
            {checkbox && (
              <Grid item>
                <Checkbox
                  classes={{ root: classes.checkbox }}
                  checked={data[key].mandatory_match || false}
                  color="primary"
                  onChange={() => {
                    setFormValue(
                      id,
                      key,
                      !data[key].mandatory_match,
                      "mandatory_match"
                    );
                  }}
                />
              </Grid>
            )}
            <Grid
              item
              style={{
                minWidth: "160px",
                maxWidth: "160px",
                marginRight: "10px",
              }}
            >
              <CustomInput
                id={`${props.id}${index}`}
                name={title + key}
                value={data[key] ? data[key].value : ""}
                onChange={(e) => setFormValue(id, key, e.target.value)}
                error={
                  !data[key].value ||
                  (errorMsg &&
                    errorMsg[key] &&
                    errorMsg[key] !== null &&
                    errorMsg[key] !== "")
                }
                helperText={errorMsg && errorMsg[key] ? errorMsg[key] : ""}
                FormHelperTextProps={{
                  classes: {
                    root: props.classes.helperText,
                  },
                }}
              />
            </Grid>
            <Grid item style={{ minWidth: typeId==135 ? "250px":"160px", maxWidth: typeId==135 ? "250px": "160px" }}>
              {renderTypeSelect(key)}
            </Grid>
            <Grid
              item
              style={{
                paddingLeft: "10px",
                height: "20px",
                paddingTop: errorMsg && errorMsg[key] ? "8px" : "0px",
              }}
            >
              <img
                src={images.deleteIcon}
                alt="delete"
                style={{ cursor: "pointer" }}
                onClick={() => setFormValue(id, key, null)}
              />
            </Grid>
          </Grid>
        ))}
      <Box
        style={{
          paddingTop: data && data.length > 0 ? "0px" : "6px",
          paddingLeft: checkbox ? "9px" : "5px",
        }}
      >
        <img
          src={images.plusIconColored}
          alt="add"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setFormValue(
              id,
              data.length,
              typeId === 133 ? 63 : typeId === 134 ? 67 : "",
              typeId
            );
          }}
        />
      </Box>
    </Box>
  );
};

MultipleFormSection.propTypes = {
  id: PropTypes.number.isRequired,
  typeId: PropTypes.number.isRequired,
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  setFormValue: PropTypes.func.isRequired,
  lov: PropTypes.object.isRequired,
  language: PropTypes.oneOf(["en", "fr"]),
  errorMsg: PropTypes.object,
  required: PropTypes.bool,
  checkbox: PropTypes.bool,
};

export default withStyles(styles)(MultipleFormSection);
